import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const shadow = {
  shadowColor: '#0000001F',
  shadowOffset: {
    width: 2,
    height: 4,
  },
  shadowRadius: 8,
}

const styles = {
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: -5,
    bottom: 0,
    flex: 1,
    // backgroundColor: 'TRANSPARENT45',
    justifyContent: 'flex-start',
    zIndex: 10000,
    underlayColor: 'TRANSPARENT',
    mt: 20,
  } as BoxProps,
  contentViewStyle: (fullWidthContent: boolean, width: number) =>
    ({
      // margin: 24,
      // marginTop: 58,
      // marginLeft: 460,
      // paddingHorizontal: 8,
      maxWidth: fullWidthContent ? width : 250,
      overflow: 'auto',
      maxHeight: 230,
      bg: 'WHITE',
      width: fullWidthContent ? '100%' : undefined,
      // padding: 16,
      // width:'40%',
      // paddingRight: 36,
      borderRadius: 5,
      alignSelf: 'flex-start',
      ...shadow,
      zIndex: 10,
    } as BoxProps),
  listStyle: {
    ...shadow,
  } as BoxProps,
  apply: {
    padding: 8,
    borderRadius: 4,
    bg: 'PRIMARY',
    align: 'center',
    justifyContent: 'center',
    underlayColor: 'PRIMARY_STORNG',
  } as BoxProps,
  cancel: {
    padding: 8,
    borderRadius: 4,
    bg: 'GRAY_HALF',
    align: 'center',
    justifyContent: 'center',
    underlayColor: 'LIGHTEST_GREY',
  } as BoxProps,
  itemView: {
    backgroundColor: 'WHITE',
    paddingHorizontal: 15,
    paddingVertical: 12,
    borderRadius: 8,
    underlayColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    align: 'center',
  } as BoxProps,
  contentContainerStyle: {
    width: '100%',
    ...shadow,
  } as ViewStyle,
  flatlistStyle: (width?: number) =>
    ({
      borderWidth: 1,
      borderRadius: 8,
      width: !!width && width > 0 ? width : '100%',
      borderColor: '#DEDEDE',
    } as ViewStyle),
}
export default styles
